import { render, staticRenderFns } from "./BankDelete.vue?vue&type=template&id=4f7dbb8d&"
import script from "./BankDelete.vue?vue&type=script&lang=js&"
export * from "./BankDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports